export const translations = {
  en: {
    nav: {
      searchPlaceholder: "Search...",
      notifications: "Notifications",
      profile: "My Profile",
      settings: "Settings",
      logout: "Logout",
      logoutSuccess: "Logged out successfully",
      operationsLead: "Operations Lead",
      counterStaff: "Counter Staff",
      deliveryStaff: "Delivery Staff",
      enterFocusMode: "Enter Focus Mode",
      exitFocusMode: "Exit Focus Mode",
    },
    sidebar: {
      brand: "Laundry Management",
      dashboard: "Dashboard",
      adminManagement: "Admin Management",
      userRoleManagement: "User & Role Management",
      customers: "Customers",
      orders: "Orders",
      invoices: "Invoices",
      branches: "Branches",
      services: "Laundry Services",
      pickups: "Home Service",
      drivers: "Drivers",
      payments: "Payments",
      staff: "Staff Management",
      reports: "Reports",
      settings: "Settings",
      auditLogs: "Audit Logs",
      assignedPickups: "Assigned Pickups",
      assignedDeliveries: "Assigned Deliveries",
      completedJobs: "Completed Jobs",
      routeSummary: "Route summary",
      routeSummaryDesc: "Pickups and deliveries assigned to you appear here in real time.",
      counterDesk: "Counter desk",
      counterDeskDesc: "Process walk-ins, payments, and order status updates from one place.",
      operations: "Admin operations",
      counterOperations: "Counter operations",
      deliveryOperations: "Delivery operations",
      newOrder: "New Order",
      makeInvoice: "Make Invoice",
      orderList: "Change invoice status",
      orderTracking: "Order Tracking",
      lcdDisplay: "LCD Display",
    },
    admin: {
      heroTitle: "Welcome back, Operations Lead",
      heroSubtitle: "Track laundry volume, dispatch readiness, and revenue performance in a clean and modern interface.",
      ordersToday: "Orders Today",
      revenueMonth: "Revenue This Month",
      readyOrders: "Ready Orders",
      deliveredOrders: "Delivered Orders",
      operationsFeed: "Operations feed",
      live: "Live",
      activityTimeline: "Activity timeline",
      quickActions: "Quick actions",
      speedUpWorkflow: "Speed up workflow",
      createOrder: "Create Order",
      createOrderHint: "Add service",
      schedulePickup: "Schedule Pickup",
      schedulePickupHint: "Dispatch driver",
      collectPayments: "Collect Payments",
      collectPaymentsHint: "Process invoice",
      systemSettings: "System Settings",
      systemSettingsHint: "Configure",
      recentOrders: "Recent Orders",
      recentOrdersDesc: "Last {count} orders from the Orders list.",
      viewAllOrders: "View all orders",
      orderNo: "Order #",
      customer: "Customer",
      service: "Service",
      status: "Status",
      payment: "Payment",
      amount: "Amount",
      date: "Date",
      dailyRevenue: "Daily Revenue",
      ordersTrend: "Orders Trend",
      serviceRevenue: "Service Revenue",
      last7Days: "Last 7 days",
      last30Days: "Last 30 days",
      weeklyVolume: "Weekly volume",
      byCategory: "By category",
      yearToDate: "Year to date",
      monthlyRevenue: "Monthly Revenue",
    },
    counter: {
      heroTitle: "Welcome back, Counter Agent",
      heroSubtitle: "Manage customers, create orders, collect payments, and track order progress.",
      ordersToday: "Orders Today",
      pendingOrders: "Pending Orders",
      readyOrders: "Ready Orders",
      deliveredOrders: "Delivered Orders",
      revenueToday: "Revenue Today",
      totalCustomers: "Total Customers",
      recentOrders: "Recent Orders",
      recentOrdersDesc: "Latest orders from the counter",
      quickActions: "Quick actions",
      speedUpWorkflow: "Speed up workflow",
      addCustomer: "Add Customer",
      createOrder: "Create Order",
      collectPayment: "Collect Payment",
      trackOrder: "Track Order",
      orderStatus: "Order status",
      statusSummary: "Status summary",
      todayActivity: "Today's activity",
      activityFeed: "Counter activity feed",
      activity: {
        orderCreated: "New order created",
        paymentCollected: "Payment collected",
        profileUpdated: "Customer profile updated",
        markedReady: "Order marked Ready",
      },
      time: {
        m10: "10 min ago",
        m25: "25 min ago",
        h1: "1 hr ago",
        h2: "2 hrs ago",
      },
      makeInvoice: {
        totalPriceLabel: "TOTAL PRICE",
        subtotalLabel: "SUB",
        selectCustomer: "Select Customer",
        typeNameOrPhone: "Type Name or Phone...",
        lookupPhone: "Lookup Phone No",
        phoneNoPlaceholder: "Phone No...",
        expectedDelivery: "Exp. Delivery",
        paperInvNo: "Paper Inv No",
        serviceType: "Service Type",
        garmentsCatalog: "Garments Catalog",
        touchToAdd: "Touch to Add",
        invoiceItems: "Invoice Items",
        clearAll: "Clear All",
        itemServiceHeader: "Item / Service",
        qtyHeader: "Qty",
        totalHeader: "Total",
        addNotesPlaceholder: "Add notes...",
        discountLabel: "Discount",
        percentLabel: "Percent",
        valueLabel: "Value",
        discountHint: "Enable checkbox to apply discount",
        taxLabel: "Tax",
        globalNotesPlaceholder: "Global notes for invoice...",
        resetButton: "Reset",
        saveButton: "Save Invoice",
        printButton: "Print Invoice",
        savePrintButton: "Save & Print Invoice",
        userNoLabel: "USER NO",
        userNameLabel: "USER NAME",
        branchLabel: "BRANCH",
        yearLabel: "YEAR",
        receiptSystemLabel: "Receipt System (نظام الإستلام)",
        selectedLabel: "Selected",
        searchPhoneTooltip: "Search Phone Number",
        removeItemTooltip: "Remove item",
        paperInvNoPlaceholder: "e.g. RG-029",
        itemsLabel: "items",
        emptyInvoiceText: "Invoice is empty.",
        emptyInvoiceSubtext: "Click items in the catalog to add them.",
        noCustomerMatch: "No customer matches query.",
        normalService: "Normal / Wash & Iron",
        ironOnlyService: "Iron Only",
        dryCleanService: "Dry Cleaning Only",
        urgentService: "Express",
        garmentBasePrice: "Base price",
        selectServicePrompt: "Select a service type to add this item",
        shirt: "Shirt",
        tshirt: "T-Shirt",
        trousers: "Trousers",
        jeans: "Jeans",
        jacket: "Jacket",
        coat: "Coat",
        suit: "Suit",
        weddingDress: "Wedding Dress",
        blanket: "Blanket",
        curtain: "Curtain",
        carpet: "Carpet",
        bedsheet: "Bedsheet",
        dishdasha: "Dishdasha",
        dishdashaPremium: "Dishdasha (Premium)",
        smallDishdasha: "Small Dishdasha",
        smallDishdashaPremium: "Small Dishdasha (Premium)",
        ghotraa: "Ghotraa",
        shmage: "Shmage",
        shmageSpecial: "Shmage (Special)",
        gahfiya: "Gahfiya",
        bisht: "Bisht",
        bigJacket: "BIG Jacket",
        militarySuit: "Military Suit",
        cap: "Cap",
        smallTrousers: "Small Trousers",
        dress: "Dress",
        schoolDress: "School Dress",
        dressingGown: "Dressing Gown",
        eveningDress: "Evening Dress",
        largeBlouse: "Large Blouse",
        skirt: "Skirt",
        smallSkirt: "Small Skirt",
        abaya: "Abaya",
        hegab: "Hegab",
        bluse: "Bluse",
        overall: "OVERALL",
        sheet: "Sheet",
        plaid: "Plaid",
        singleQuilt: "Single quilt",
        doubleQuilt: "Double quilt",
        dueBalance: "Due Balance",
        settleAndPay: "Settle & Pay",
        sendToWhatsApp: "Send to WhatsApp",
        expressLabel: "EXPRESS",
        normalLabel: "Normal",
        normalServiceShort: "Normal service",
        addCatalog: "Add Catalog",
        addCustomCatalog: "Add Custom Catalog",
        catalogFormSubtitle: "Enter garment details to add to the catalog",
        garmentName: "Garment Name",
        garmentNamePlaceholder: "e.g. Sherwani, Abaya, Kurta...",
        garmentNameRequired: "Garment name is required",
        autoIconPreview: "Auto-matched icon preview",
        customUploadedImage: "Custom uploaded image",
        hasMultipleSizes: "Item has multiple sizes?",
        basePriceKwd: "Base Price (KWD)",
        sizesAndPrices: "Sizes & Prices",
        addToCatalog: "Add to Catalog",
        editCatalogItem: "Edit Catalog Item",
        doneEditing: "Done Editing",
        editCatalog: "Edit Catalog",
        doneRemoving: "Done Removing",
        removeCatalog: "Remove Catalog",
        cardPayment: "Card Payment",
        linkPayment: "Link Payment",
        creditPayment: "Credit Payment",
        back: "Back",
        paymentCash: "CASH",
        paymentBukey: "BUKEY",
        paymentCard: "BUKEY",
        paymentKnet: "K-NET",
        paymentLink: "K-NET",
        paymentCredit: "CREDIT",
        nameOnCard: "Name on Card",
        cardNumber: "Card Number",
        expiry: "Expiry",
        cvv: "CVV",
        payNow: "Pay Now",
        sendLink: "Send Link",
        confirmCredit: "Confirm Credit",
        creditDebit: "CREDIT / DEBIT",
        cardHolder: "CARD HOLDER",
        enterArabicNameHint: "Enter name in Arabic for Arabic display",
        expressIroningPrice: "Express Ironing",
        expressWashIronPrice: "Express Wash & Iron",
        normalIroningPrice: "Normal Ironing",
        normalWashIronPrice: "Normal Wash & Iron",
        selectColor: "Select Color",
        customImage: "Custom Image",
        editGarment: "Edit Garment",
        pricePlaceholder: "e.g. 1.500",
        atLeastOnePriceRequired: "Set at least one service price",
        homeDelivery: "Home Delivery",
        shopPickup: "Shop Pickup",
        branchPickup: "Branch Pickup",
        deliveryType: "Delivery Type",
      }
    },
    delivery: {
      heroTitle: "Welcome back, Dispatch Rider",
      heroSubtitle: "Handle pickups and deliveries assigned by admin.",
      assignedTo: "Assigned to",
      assignedPickups: "Assigned Pickups",
      assignedDeliveries: "Assigned Deliveries",
      completedJobs: "Completed Jobs",
      todayDeliveries: "Today's Deliveries",
      todaySchedule: "Today's Schedule",
      noJobsToday: "No jobs scheduled for today.",
      upcomingDeliveries: "Upcoming Deliveries",
      viewAllDeliveries: "View all deliveries →",
      pickupRequests: "Pickup Requests",
      viewAllPickups: "View all pickups →",
      deliveryPerformance: "Delivery Performance",
      completed: "Completed",
      pending: "Pending",
      successRate: "Success rate",
      printList: "Print List",
      assignedDeliveriesList: "Assigned Deliveries List",
      noDeliveriesToPrint: "No deliveries to print",
    },
    common: {
      active: "Active",
      inactive: "Inactive",
      all: "All",
      status: "Status",
      exit: "Exit",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      new: "New",
      close: "Close",
      toggleMenu: "Toggle menu",
    }
  },
  ar: {
    nav: {
      searchPlaceholder: "البحث...",
      notifications: "الإشعارات",
      profile: "الملف الشخصي",
      settings: "الإعدادات",
      logout: "تسجيل الخروج",
      logoutSuccess: "تم تسجيل الخروج بنجاح",
      operationsLead: "مدير العمليات",
      counterStaff: "موظف الاستقبال",
      deliveryStaff: "موظف التوصيل",
      enterFocusMode: "وضع التركيز",
      exitFocusMode: "إلغاء وضع التركيز",
    },
    sidebar: {
      brand: "تهامة",
      dashboard: "لوحة التحكم",
      adminManagement: "إدارة المسؤولين",
      userRoleManagement: "إدارة المستخدمين والأدوار",
      customers: "العملاء",
      orders: "الطلبات",
      invoices: "الفواتير",
      branches: "الفروع",
      services: "خدمات الغسيل",
      pickups: "الخدمة المنزلية",
      drivers: "السائقين",
      payments: "المدفوعات",
      staff: "إدارة الموظفين",
      reports: "التقارير",
      settings: "الإعدادات",
      auditLogs: "سجلات التدقيق",
      assignedPickups: "طلبات الاستلام",
      assignedDeliveries: "طلبات التوصيل",
      completedJobs: "المهام المكتملة",
      routeSummary: "ملخص المسار",
      routeSummaryDesc: "تظهر طلبات الاستلام والتوصيل المسندة إليك هنا في الوقت الفعلي.",
      counterDesk: "مكتب الاستقبال",
      counterDeskDesc: "معالجة الزوار، والمدفوعات، وتحديثات حالة الطلب من مكان واحد.",
      operations: "عمليات المسؤول",
      counterOperations: "عمليات الاستقبال",
      deliveryOperations: "عمليات التوصيل",
      newOrder: "طلب جديد",
      makeInvoice: "إنشاء فاتورة",
      orderList: "قائمة الطلبات",
      orderTracking: "تتبع الطلب",
      lcdDisplay: "شاشة العرض",
    },
    admin: {
      heroTitle: "أهلاً بك مجدداً، مدير العمليات",
      heroSubtitle: "تتبع حجم الغسيل، وجاهزية الإرسال، وأداء الإيرادات في واجهة مستخدم نظيفة وحديثة.",
      ordersToday: "طلبات اليوم",
      revenueMonth: "إيرادات هذا الشهر",
      readyOrders: "الطلبات الجاهزة",
      deliveredOrders: "الطلبات المسلمة",
      operationsFeed: "تغذية العمليات",
      live: "مباشر",
      activityTimeline: "مخطط النشاط",
      quickActions: "إجراءات سريعة",
      speedUpWorkflow: "تسريع سير العمل",
      createOrder: "إنشاء طلب",
      createOrderHint: "إضافة خدمة",
      schedulePickup: "جدولة استلام",
      schedulePickupHint: "إرسال السائق",
      collectPayments: "تحصيل المدفوعات",
      collectPaymentsHint: "معالجة الفاتورة",
      systemSettings: "إعدادات النظام",
      systemSettingsHint: "تكوين الإعدادات",
      recentOrders: "أحدث الطلبات",
      recentOrdersDesc: "آخر {count} طلبات من قائمة الطلبات.",
      viewAllOrders: "عرض كل الطلبات",
      orderNo: "رقم الطلب",
      customer: "العميل",
      service: "الخدمة",
      status: "الحالة",
      payment: "الدفع",
      amount: "المبلغ",
      date: "التاريخ",
      dailyRevenue: "الإيرادات اليومية",
      ordersTrend: "اتجاه الطلبات",
      serviceRevenue: "إيرادات الخدمات",
      last7Days: "آخر 7 أيام",
      last30Days: "آخر 30 يوماً",
      weeklyVolume: "الحجم الأسبوعي",
      byCategory: "حسب الفئة",
      yearToDate: "منذ بداية العام",
      monthlyRevenue: "الإيرادات الشهرية",
    },
    counter: {
      heroTitle: "أهلاً بك مجدداً، وكيل الاستقبال",
      heroSubtitle: "إدارة العملاء، وإنشاء الطلبات، وتحصيل المدفوعات، وتتبع تقدم الطلب.",
      ordersToday: "طلبات اليوم",
      pendingOrders: "الطلبات المعلقة",
      readyOrders: "الطلبات الجاهزة",
      deliveredOrders: "الطلبات المسلمة",
      revenueToday: "إيرادات اليوم",
      totalCustomers: "إجمالي العملاء",
      recentOrders: "أحدث الطلبات",
      recentOrdersDesc: "أحدث الطلبات من الاستقبال",
      quickActions: "إجراءات سريعة",
      speedUpWorkflow: "تسريع سير العمل",
      addCustomer: "إضافة عميل",
      createOrder: "إنشاء طلب",
      collectPayment: "تحصيل الدفع",
      trackOrder: "تتبع الطلب",
      orderStatus: "حالة الطلب",
      statusSummary: "ملخص الحالة",
      todayActivity: "نشاط اليوم",
      activityFeed: "تغذية نشاط الاستقبال",
      activity: {
        orderCreated: "تم إنشاء طلب جديد",
        paymentCollected: "تم تحصيل الدفع",
        profileUpdated: "تم تحديث ملف العميل",
        markedReady: "تم تمييز الطلب كجاهز",
      },
      time: {
        m10: "منذ 10 دقائق",
        m25: "منذ 25 دقيقة",
        h1: "منذ ساعة",
        h2: "منذ ساعتين",
      },
      makeInvoice: {
        totalPriceLabel: "إجمالي السعر",
        subtotalLabel: "الفرعي",
        selectCustomer: "اختر العميل",
        typeNameOrPhone: "اكتب الاسم أو الهاتف...",
        lookupPhone: "البحث برقم الهاتف",
        phoneNoPlaceholder: "رقم الهاتف...",
        expectedDelivery: "تاريخ التسليم",
        paperInvNo: "رقم الفاتورة الورقية",
        serviceType: "نوع الخدمة",
        garmentsCatalog: "كتالوج الملابس",
        touchToAdd: "اضغط للإضافة",
        invoiceItems: "عناصر الفاتورة",
        clearAll: "مسح الكل",
        itemServiceHeader: "الصنف / الخدمة",
        qtyHeader: "الكمية",
        totalHeader: "الإجمالي",
        addNotesPlaceholder: "إضافة ملاحظات...",
        discountLabel: "الخصم",
        percentLabel: "نسبة",
        valueLabel: "قيمة",
        discountHint: "فعل خيار الخصم لتطبيق الخصم",
        taxLabel: "الضريبة",
        globalNotesPlaceholder: "ملاحظات عامة للفاتورة...",
        resetButton: "إعادة تعيين",
        saveButton: "حفظ الفاتورة",
        printButton: "طباعة الفاتورة",
        savePrintButton: "حفظ وطباعة الفاتورة",
        userNoLabel: "رقم المستخدم",
        userNameLabel: "اسم المستخدم",
        branchLabel: "الفرع",
        yearLabel: "السنة",
        receiptSystemLabel: "نظام الاستلام",
        selectedLabel: "تم الاختيار",
        searchPhoneTooltip: "البحث برقم الهاتف",
        removeItemTooltip: "حذف العنصر",
        paperInvNoPlaceholder: "مثال: RG-029",
        itemsLabel: "عنصر",
        emptyInvoiceText: "الفاتورة فارغة.",
        emptyInvoiceSubtext: "اضغط على العناصر في الكتالوج لإضافتها.",
        noCustomerMatch: "لا يوجد عميل يطابق البحث.",
        normalService: "عادي / غسيل وكوي",
        ironOnlyService: "كوي فقط",
        dryCleanService: "غسيل جاف فقط",
        urgentService: "مستعجل / ممتاز",
        garmentBasePrice: "السعر الأساسي",
        selectServicePrompt: "اختر نوع الخدمة لإضافة هذا الصنف",
        shirt: "قميص",
        tshirt: "تي شيرت",
        trousers: "بنطلون",
        jeans: "جينز",
        jacket: "جاكيت",
        coat: "معطف",
        suit: "بدلة",
        weddingDress: "فستان زفاف",
        blanket: "بطانية",
        curtain: "ستارة",
        carpet: "سجاد",
        bedsheet: "شرشف سرير",
        dishdasha: "دشداشة",
        dishdashaPremium: "دشداشة (ممتاز)",
        smallDishdasha: "دشداشة صغير",
        smallDishdashaPremium: "دشداشة صغير (ممتاز)",
        ghotraa: "غترة",
        shmage: "شماغ",
        shmageSpecial: "شماغ (خاص)",
        gahfiya: "قحفية",
        bisht: "بشت",
        bigJacket: "جاكيت كبير",
        militarySuit: "بدلة عسكرية",
        cap: "كاب",
        smallTrousers: "بنطلون صغير",
        dress: "فستان",
        schoolDress: "فستان مدرسة",
        dressingGown: "روب منزلي",
        eveningDress: "فستان سهرة",
        largeBlouse: "بلوزة كبيرة",
        skirt: "تنورة",
        smallSkirt: "تنورة صغيرة",
        abaya: "عباية",
        hegab: "حجاب",
        bluse: "بلوزة",
        overall: "أوفرول",
        sheet: "شرشف",
        plaid: "بطانية خفيفة",
        singleQuilt: "لحاف مفرد",
        doubleQuilt: "لحاف مزدوج",
        dueBalance: "الرصيد المستحق",
        settleAndPay: "تسوية ودفع",
        sendToWhatsApp: "إرسال عبر واتساب",
        expressLabel: "مستعجل",
        normalLabel: "عادي",
        normalServiceShort: "خدمة عادية",
        addCatalog: "إضافة للكتالوج",
        addCustomCatalog: "إضافة قطعة مخصصة",
        catalogFormSubtitle: "أدخل تفاصيل القطعة لإضافتها إلى الكتالوج",
        garmentName: "اسم القطعة",
        garmentNamePlaceholder: "مثال: شيرواني، عباية، كُرتا...",
        garmentNameRequired: "اسم القطعة مطلوب",
        autoIconPreview: "معاينة الأيقونة التلقائية",
        customUploadedImage: "صورة مرفوعة مخصصة",
        hasMultipleSizes: "هل للقطعة مقاسات متعددة؟",
        basePriceKwd: "السعر الأساسي (د.ك)",
        sizesAndPrices: "المقاسات والأسعار",
        addToCatalog: "إضافة للكتالوج",
        editCatalogItem: "تعديل قطعة الكتالوج",
        doneEditing: "إنهاء التعديل",
        editCatalog: "تعديل الكتالوج",
        doneRemoving: "إنهاء الحذف",
        removeCatalog: "حذف من الكتالوج",
        cardPayment: "الدفع بالبطاقة",
        linkPayment: "الدفع بالرابط",
        creditPayment: "الدفع بالآجل",
        back: "رجوع",
        paymentCash: "نقدي",
        paymentBukey: "بوكيه / باقة",
        paymentCard: "بوكيه / باقة",
        paymentKnet: "كي نت",
        paymentLink: "كي نت",
        paymentCredit: "آجل",
        nameOnCard: "الاسم على البطاقة",
        cardNumber: "رقم البطاقة",
        expiry: "تاريخ الانتهاء",
        cvv: "رمز التحقق",
        payNow: "ادفع الآن",
        sendLink: "إرسال الرابط",
        confirmCredit: "تأكيد الآجل",
        creditDebit: "ائتمان / خصم",
        cardHolder: "حامل البطاقة",
        enterArabicNameHint: "أدخل الاسم بالعربية للعرض باللغة العربية",
        expressIroningPrice: "كوي مستعجل",
        expressWashIronPrice: "غسيل وكوي مستعجل",
        normalIroningPrice: "كوي عادي",
        normalWashIronPrice: "غسيل وكوي عادي",
        selectColor: "اختر اللون",
        customImage: "صورة مخصصة",
        editGarment: "تعديل القطعة",
        pricePlaceholder: "مثال: 1.500",
        atLeastOnePriceRequired: "يرجى تحديد سعر خدمة واحد على الأقل",
        homeDelivery: "توصيل منزلي",
        shopPickup: "استلام من الفرع",
        branchPickup: "استلام من الفرع",
        deliveryType: "نوع التوصيل",
      }
    },
    delivery: {
      heroTitle: "أهلاً بك مجدداً، مندوب التوصيل",
      heroSubtitle: "إدارة طلبات الاستلام والتوصيل المسندة من قبل المسؤول.",
      assignedTo: "مسند إلى",
      assignedPickups: "طلبات الاستلام",
      assignedDeliveries: "طلبات التوصيل",
      completedJobs: "المهام المكتملة",
      todayDeliveries: "توصيلات اليوم",
      todaySchedule: "جدول اليوم",
      noJobsToday: "لا توجد مهام مجدولة لليوم.",
      upcomingDeliveries: "التوصيلات القادمة",
      viewAllDeliveries: "عرض كل التوصيلات ←",
      pickupRequests: "طلبات الاستلام",
      viewAllPickups: "عرض كل طلبات الاستلام ←",
      deliveryPerformance: "أداء التوصيل",
      completed: "مكتمل",
      pending: "معلق",
      successRate: "نسبة النجاح",
      printList: "طباعة القائمة",
      assignedDeliveriesList: "قائمة التوصيلات المسندة",
      noDeliveriesToPrint: "لا توجد توصيلات للطباعة",
    },
    common: {
      active: "نشط",
      inactive: "غير نشط",
      all: "الكل",
      status: "الحالة",
      exit: "خروج",
      save: "حفظ",
      cancel: "إلغاء",
      edit: "تعديل",
      delete: "حذف",
      new: "جديد",
      close: "إغلاق",
      toggleMenu: "تبديل القائمة",
    }
  }
};
